import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ELI from "../../assets/img/ELI LOGO.png";
import "../../assets/css/style.css";
import swal from "sweetalert";
import axios from "axios";
import BASE_URL from "../../assets/global/url";
import useCompanyProfile from "../../hooks/customHook/useCompanyProfile";

const NewPassword = () => {
  const navigate = useNavigate();
  const { company, loading } = useCompanyProfile();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [userID, setUserID] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
  };

  const [validation, setValidation] = useState({
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    isLongEnough: false,
    passwordsMatch: false,
    hasSpecialChar: false,
  });

  useEffect(() => {
    setValidation({
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      isLongEnough: password.length >= 8,
      passwordsMatch:
        password && confirmPassword ? password === confirmPassword : false,
    });
  }, [password, confirmPassword]);

  const handleSubmit = async (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      setEmailError(true);
      swal({
        title: "Incorrect Email Format",
        text: "Please enter a valid email address",
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return;
    } else {
      setEmailError(false);
    }

    if (password !== confirmPassword) {
      setPasswordError(true);
      swal({
        title: "Password not matched",
        text: "Please check your password",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
      return;
    } else {
      setPasswordError(false);
    }

    swal({
      title: "Are you sure?",
      text: "Click OK to change password",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        try {
          axios
            .post(BASE_URL + "/newPassword/changePassword", {
              password,
              email,
              userID,
            })
            .then((response) => {
              if (response.status === 200) {
                swal({
                  title: "Success!",
                  text: "Password has been changed successfully",
                  icon: "success",
                  buttons: false,
                  timer: 2000,
                }).then(() => {
                  navigate("/");
                });
              }
            })
            .catch((error) => {
              if (error.response && error.response.status === 404) {
                swal({
                  title: "User Not Found",
                  text: "Incorrect User ID or Email",
                  icon: "error",
                });
              } else if (error.response && error.response.status === 500) {
                swal({
                  title: "Server Error",
                  text: "Failed to update password. Please contact our support team.",
                  icon: "error",
                });
              } else {
                swal({
                  title: "Something Went Wrong",
                  text: "Please contact our support team.",
                  icon: "error",
                });
              }
            });
        } catch (error) {
          console.error("Error changing password:", error);
          swal({
            title: "Error!",
            text: "Something went wrong.",
            icon: "error",
            buttons: false,
            timer: 2000,
          });
        }
      }
    });
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light login-container py-4">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4">
            <div className="bg-white p-4 custom-login-form shadow rounded">
              <div className="text-center mb-3">
                <img
                  src={
                    !loading && company && company.profile_picture
                      ? `data:image/jpeg;base64,${company.profile_picture}`
                      : ELI
                  }
                  alt="Company Logo"
                  className="img-fluid"
                  style={{ maxWidth: "160px", width: "100%" }}
                />
              </div>
              <div className="text-center mb-4">
                <h1 className="mb-1 fs-4 fw-bold">Change Password</h1>
                <p className="text-muted small mb-0">
                  Enter your new password to complete the process
                </p>
              </div>

              <div className="mb-3">
                <label
                  htmlFor="userID"
                  className="form-label small fw-semibold">
                  User ID <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="userID"
                  placeholder="Enter User ID"
                  required
                  className="form-control"
                  value={userID}
                  onChange={(e) => setUserID(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="email" className="form-label small fw-semibold">
                  Email Address <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter Email"
                  required
                  className={`form-control ${emailError ? "border-danger" : ""}`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label
                  htmlFor="password"
                  className="form-label small fw-semibold">
                  New Password <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className={`form-control ${passwordError ? "border-danger" : ""}`}
                    id="password"
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <i
                    className={`fa-solid ${
                      showPassword ? "fa-eye-slash" : "fa-eye"
                    } position-absolute cursor-pointer text-muted`}
                    onClick={togglePasswordVisibility}
                    style={{
                      top: "50%",
                      right: "12px",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                    }}></i>
                </div>
              </div>

              <div className="mb-3">
                <label
                  htmlFor="confirmPassword"
                  className="form-label small fw-semibold">
                  Confirm Password <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className={`form-control ${passwordError ? "border-danger" : ""}`}
                    id="confirmPassword"
                    placeholder="Enter Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                  <i
                    className={`fa-solid ${
                      showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                    } position-absolute cursor-pointer text-muted`}
                    onClick={toggleConfirmPasswordVisibility}
                    style={{
                      top: "50%",
                      right: "12px",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                    }}></i>
                </div>
              </div>

              {/* Validation Checklist - Changed to Two Columns */}
              <div
                className="row small text-muted mt-1 mb-4"
                style={{ fontSize: "0.80rem" }}>
                <div className="col-6">
                  <div
                    style={{
                      color: validation.hasUpperCase ? "#198754" : "#dc3545",
                    }}>
                    {validation.hasUpperCase ? "✔ " : "✘ "} 1 Uppercase
                  </div>
                  <div
                    style={{
                      color: validation.hasLowerCase ? "#198754" : "#dc3545",
                    }}>
                    {validation.hasLowerCase ? "✔ " : "✘ "} 1 Lowercase
                  </div>
                  <div
                    style={{
                      color: validation.hasNumber ? "#198754" : "#dc3545",
                    }}>
                    {validation.hasNumber ? "✔ " : "✘ "} 1 Number
                  </div>
                </div>
                <div className="col-6">
                  <div
                    style={{
                      color: validation.hasSpecialChar ? "#198754" : "#dc3545",
                    }}>
                    {validation.hasSpecialChar ? "✔ " : "✘ "} 1 Special Char
                  </div>
                  <div
                    style={{
                      color: validation.isLongEnough ? "#198754" : "#dc3545",
                    }}>
                    {validation.isLongEnough ? "✔ " : "✘ "} 8+ Characters
                  </div>
                  <div
                    style={{
                      color: validation.passwordsMatch ? "#198754" : "#dc3545",
                    }}>
                    {validation.passwordsMatch ? "✔ " : "✘ "} Match
                  </div>
                </div>
              </div>

              <div className="d-grid">
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={!Object.values(validation).every(Boolean)}
                  className="btn btn-primary">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
